import { createComment } from './createComment.js';

export namespace CommentsAPI {
  export const create = createComment;
}
